import {CursorBasedPaginationResponse, QueryBaseTypeWithCursorPaginationWhereAndOrder} from 'api/common';

export interface NoteModel {
    id?: string;
    title: string;
    description: string;
    createdDate: string;
}

export interface NoteCreateUpdateRequest extends Omit<NoteModel, 'createdDate'> {}
export interface NoteListingRequest extends QueryBaseTypeWithCursorPaginationWhereAndOrder<NoteModel> {}
export interface NoteListingRespone extends NoteModel {}
export interface NoteResponse extends NoteModel {}

export interface NotePaginationResponse {
    allNotes: CursorBasedPaginationResponse<NoteModel>;
}
export const noteDefaultValues: NoteCreateUpdateRequest = {
    title: '',
    description: '',
};
